import { render, staticRenderFns } from "./UMLVOAddress.vue?vue&type=template&id=6aea5d98&scoped=true&"
import script from "./UMLVOAddress.vue?vue&type=script&lang=js&"
export * from "./UMLVOAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aea5d98",
  null
  
)

export default component.exports